<template>
  <div class="b-dialog" v-loading="loading">
    <el-dialog :visible.sync="visible" :title="title" :width="width" :lock-scroll="lockScroll" :destroy-on-close="destroyOnClose" :close-on-click-modal="closeOnClickModal"
      @close="$listeners.close ? ()=> $listeners.close() : ($listeners.cancel ? () => $listeners.cancel() : () => false)">
      <div class="b-dialog-body">
        <slot />
      </div>
      <div :class="['b-dialog-foot', (($listeners.finish || $listeners.submit || $listeners.cancel) ? 'custom' : null)]">
        <div v-if="($listeners.finish || $listeners.submit || $listeners.cancel)">
          <el-button v-if="$listeners.finish && finishText != ''" :loading="loading" @click="this.verify" type="success">{{finishText}}</el-button>
          <el-button v-if="$listeners.submit && finishText != ''" :loading="loading" @click="this.verify" type="primary">{{submitText}}</el-button>
          <el-button v-if="$listeners.cancel && finishText != ''" :disabled="loading" @click="() => $listeners.cancel()">{{cancelText}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Bdialog',
  props: {
    title: { type: String, default: () => '编辑' },
    width: { type: String, default: () => '600px' },
    loading: { type: Boolean, default: () => false },
    lockScroll: { type: Boolean, default: () => true },
    destroyOnClose: { type: Boolean, default: () => true },
    closeOnClickModal: { type: Boolean, default: () => false },
    visible: { type: Boolean, default: () => false },
    finishText: { type: String, default: () => '保存' },
    submitText: { type: String, default: () => '确定' },
    cancelText: { type: String, default: () => '取消' },
  },
  methods: {
    verify() {
      let pass = true;
      let elements = this.$slots.default;
      elements && elements.length && elements.length > 0 && elements.forEach(a => {
        if ((a && a.componentInstance && a.componentInstance.verify) && !a.componentInstance.verify()) pass = false;
      });
      if (pass) {
        this.$emit('finish', pass);
        this.$emit('submit', pass);
      }
    },
  },
}
</script>

<style scoped>
@import "index.css";
</style>